document.addEventListener("DOMContentLoaded", function () {
  const mainWrapper = document.querySelector(".container-quick-options")
  const ID_SECTION = "api-quick-options";
  const hotspotImages = document.querySelectorAll(".hotspot-image");
  const productWrappers = document.querySelectorAll(".hotspot-products__wrapper");
  const buttonQuickOptions = document.querySelectorAll(".best-sellers__quick-option");


  productWrappers.forEach( wrapper => wrapper.addEventListener("click", function(event) {
    if (event.target.hasAttribute("data-selector-input")) {
      const inputId = event.target.dataset.selectorInput;
      const labelInQuickOptions = document.querySelector(`.product-form__row [data-selector-input="${inputId}"]`)
      if (labelInQuickOptions && mainWrapper.classList.contains("container-quick-options--active")) {
        labelInQuickOptions?.click();
      }
    }
  }))


  hotspotImages.forEach((hotspot) =>
    hotspot.addEventListener("click", toggleContent)
  );
  buttonQuickOptions.forEach((button,index) =>
    button.addEventListener("click", async function () {
      await renderQuickOptions.bind(button)(null);
      initFirstColor(button.closest(".best-sellers__product"));
      changeAttrActive(button.closest(".hotspot-products__wrapper"));
    })
  );

  function changeAttrActive(selector) {
    if (!selector || selector.getAttribute("data-active") == "true" ) return;
    productWrappers.forEach(wrapper => wrapper.setAttribute("data-active","false"));
    selector.setAttribute("data-active","true")
  }

  function initFirstColor(selector) {
    if (!selector) return;
    const cardInputColor = selector.querySelectorAll(".best-sellers__variants input");
    cardInputColor.forEach( input => {
      if (!input.checked) return;
      const {dataset: {selectorInput}} = input;
      const labelInQuickOptions = document.querySelector(`.form__row-label[data-selector-input="${selectorInput}"]`);
      labelInQuickOptions?.click();
    })
  }
  function toggleContent() {
    const isActive = this.classList.contains("hotspot-image--active");
    this.classList.toggle("hotspot-image--active", !isActive);
  }

  async function renderQuickOptions(id) {
    let {
      dataset: { url },
    } = this;
    if (!url) return;
    // const productUrl = `${url}?section_id=${ID_SECTION}`;
    const productUrl = id
      ? `${url}?variant=${id}&section_id=${ID_SECTION} `
      : `${url}?section_id=${ID_SECTION}`;
    try {
      const markup = await getMarkup(productUrl);
      const source = markup.querySelector("#quick-options");
      document.querySelector("#quick-options").replaceWith(source);
      toggleStateContent(true)
      changeStateQuickOptions(mainWrapper).active();
    } catch (error) {
      console.error("Error fetching quick options markup:", error);
    }
  }


  function toggleStateContent(isShow) {
    mainWrapper?.classList.toggle("container-quick-options--active",isShow)
  }

  async function getMarkup(path) {
    try {
      const response = await fetch(path);
      const resText = await response.text();
      const html = new DOMParser().parseFromString(resText, "text/html");
      changeStateQuickOptions(mainWrapper).disabled();
      return html.querySelector(".shopify-section");
    } catch (error) {
      console.error("Error fetching quick options markup:", error);
    }
  }
  function changeStateQuickOptions(container) {
    if (!container) return;
    return {
      disabled: function() {
        container.classList.add("disabled-container");
      },
      active: function() {
        container.classList.remove("disabled-container");
      }
    }
  }

  class QuickOptions extends HTMLElement {
    constructor() {
      super();
      this.inputs = this.querySelectorAll(".form__row-input");
      this.inputColor = this.querySelectorAll(".form__row--color .form__row-input");
      this.json =
        JSON.parse(this.querySelector("#ProductJsonQuick").innerHTML)
          ?.variants || [];
      this.form = this.querySelector("form");
      this.closeButton =this.querySelector(".product-quick-options__close")



      this.initColorSwatch();
      this.inputs.forEach((input) => {
        input.addEventListener("change", this.findCorrectId.bind(this));
      });
      this.inputColor.forEach((input) => {
        input.addEventListener("change", () => {
          this.changeColor.bind(this)(input)
        });
      });


      this.form.addEventListener("submit", this.addToCart.bind(this));
      this.closeButton.addEventListener("click", ()=> {
        toggleStateContent(false)
      })
    }
    changeColor(input) {
      if (!input) return;
      const {dataset: {product}, value}= input;
      const selectorLabel = `${product}-${String(value).toLocaleLowerCase()}`;
      const nodeLabel = document.querySelector(`.hotspot-products__wrapper[data-active="true"] [data-selector="${selectorLabel}"]`);
      nodeLabel?.click();
    }
    addToCart(event) {
      event.preventDefault();
      const idVariant = this.querySelector("[data-productid]").value;
      if (!idVariant) {
        console.error("No variant ID found.");
        return;
      }

      const formData = {
        items: [
          {
            id: idVariant,
            quantity: 1,
          },
        ],
      };

      const request = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      };

      fetch(window.Shopify.routes.root + "cart/add.js", request)
        .then(handleResponse)
        .then(updateCart)
        .catch(handleError)
        .finally( setTimeout(() => {
            toggleStateContent(false)
        }, 500))

      function handleResponse(response) {
        if (!response.ok) {
          throw new Error("Network response was not ok.");
        }
        return response.json();
      }

      function updateCart(response) {
        document.dispatchEvent(
          new CustomEvent("upsell:updateCart", { bubbles: true })
        );
      }

      function handleError(error) {
        console.error("Error:", error);
      }
    }
    findCorrectId() {
      const optionsObj = {
        option1: null,
        option2: null,
        option3: null,
      };

      this.inputs.forEach((input) => {
        if (!input.checked) return;
        const {
          dataset: { position },
          value,
        } = input;
        optionsObj[position] = value;
      });

      const correctVariant = [...this.json].find(
        (variant) =>
          variant.option1 === optionsObj.option1 &&
          variant.option2 === optionsObj.option2 &&
          variant.option3 === optionsObj.option3
      );
      if (correctVariant && correctVariant.id) {
        const { id } = correctVariant;
        renderQuickOptions.bind(this)(id);
      }
    }

    async initColorSwatch() {
      try {
        const response = window.colorSwatch
          ? window.colorSwatch
          : await fetch(window.theme.assets.swatches);
        const data = window.colorSwatch
          ? window.colorSwatch
          : await response.json();
        const dataColors = data.colors;
        const colorsLabel = document.querySelectorAll(".form__row-label");

        colorsLabel.forEach((colorLabel) => {
          let colorData = colorLabel.dataset.attrColor;
          dataColors.forEach((colorObj) => {
            const colorName = Object.keys(colorObj)[0];
            if (colorName === colorData) {
              let colorSpan = colorLabel.querySelector("span");
              colorSpan.style.backgroundColor = colorObj[colorName];
            }
          });
        });
      } catch (error) {
        console.error("Error fetching colors:", error);
      }
    }
  }
  customElements.define("quick-options", QuickOptions);
});
